import { useTranslation } from 'next-i18next';

import CertificateCriteriaStyle from './style';

import { ICourseItem } from 'src/interfaces';

type Props = {
  criteriaLearnPercent?: number;
  courseItems?: ICourseItem[];
};

const CertificateCriteria = ({ criteriaLearnPercent, courseItems }: Props) => {
  const { t } = useTranslation('common');
  const hasCriteriaQuizCourseItems = courseItems?.filter((item: ICourseItem) => item.is_criteria);

  return (
    <CertificateCriteriaStyle>
      <p>
        {t('course_detail.certificate_criteria.description')}
        <br />
        {criteriaLearnPercent && (
          <>
            <span>
              {t('course_detail.certificate_criteria.learn_percent', {
                criteria_learn_percent: criteriaLearnPercent,
              })}
            </span>
            <br />
          </>
        )}
        {hasCriteriaQuizCourseItems?.map((item) => (
          <>
            <span>
              {t('course_detail.certificate_criteria.quiz_score', {
                quiz_name: item.quizzes?.name,
                criteria_score: item.criteria_score,
              })}
            </span>
            <br />
          </>
        ))}
      </p>
    </CertificateCriteriaStyle>
  );
};

export default CertificateCriteria;
